import React from 'react';
import { PrivacyPolicyContent } from '../../../shared/legal/PrivacyPolicyContent';
import LandingPolicyShell from '../components/LandingPolicyShell';

export default function PrivacyPolicy() {
    return (
        <LandingPolicyShell title="Privacy Policy">
            <PrivacyPolicyContent variant="page" />
        </LandingPolicyShell>
    );
}
